import { render, staticRenderFns } from "./GateTabs.vue?vue&type=template&id=3bcd40db&scoped=true&"
import script from "./GateTabs.vue?vue&type=script&lang=js&"
export * from "./GateTabs.vue?vue&type=script&lang=js&"
import style0 from "./GateTabs.vue?vue&type=style&index=0&id=3bcd40db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd40db",
  null
  
)

export default component.exports